module.exports = __webpack_public_path__ + "img/mifinity.54dc7626.svg";